module.exports = __webpack_public_path__ + "static/media/webdesign-services-img38.5f16f1a0.jpg";